import { API_STATES } from "@/helpers";

const state = {
  requestAccrualTemplatesGetState : API_STATES.NOT_REQUESTED,
  requestAccrualTemplatesGetError : null,
  requestAccrualTemplates         : []
};

export default state;